import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 13.867 15.848',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2" transform="translate(0 0.002)">
        <path
          fill={fill}
          d="M74.476,7.933H72V5.7a4.7,4.7,0,0,1,9.41,0V7.933H78.933V5.7a2.229,2.229,0,0,0-4.457,0Z"
          transform="translate(-69.771 -1)"
          opacity="0.5"
        />
        <path
          fill={fill}
          d="M12.381,225H1.486A1.486,1.486,0,0,0,0,226.486v5.943a1.486,1.486,0,0,0,1.486,1.486h10.9a1.486,1.486,0,0,0,1.486-1.486v-5.943A1.486,1.486,0,0,0,12.381,225Zm-4.21,5.169a1.238,1.238,0,0,1-2.476,0v-1.486a1.238,1.238,0,1,1,2.476,0Z"
          transform="translate(0 -218.067)"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
